// スコア（0-100）→ 信号色レベル
export type ScoreLevel = 'high' | 'mid' | 'low'

export const scoreLevel = (score: number): ScoreLevel =>
  score >= 70 ? 'high' : score >= 40 ? 'mid' : 'low'
